import { render } from "./TheHeader.vue?vue&type=template&id=6ed9aeee"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\lifet\\workspace\\cna\\cnanonsul-master\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__